import { acceptableFileFormats } from 'constants/global.constants';
import { userMesaageType } from 'constants/ui.constants';
import _ from 'lodash';
import { store } from 'state/store';

export const translatedCancelPopup = (cancelPopupProps) => {
	const t = store.getState().translation.translations;
	const obj = {};
	Object.entries(cancelPopupProps).forEach(([key, value]) => {
		obj[key] = t[value as string];
	});
	return obj;
};

export const setErrorMessage = (setMessage: any, error: any) => {
	console.log('error', error);

	store.dispatch(
		setMessage({
			exist: true,
			type: userMesaageType.ERROR,
			text: error.data?.code
				? 'servers.errors.codes.' + _.get(error, 'data.error_number', 500)
				: 'servers.errors.general.' + _.get(error, 'statusCode', 500),
			subText: error?.data?.error
				? error?.data?.error
				: error?.data?.code
				? 'servers.errors.codes.' + _.get(error, 'data.error_number', 500) + '.subtitle'
				: {},
		})
	);
};

export const setErrorFieldsMessage = (setMessage: any, error: any, fields?: any) => {
	store.dispatch(
		setMessage({
			exist: true,
			type: userMesaageType.ERROR,
			text: error.data?.code
				? 'servers.errors.codes.' + error.data.error_number
				: 'servers.errors.general.' + error.statusCode,
			subText: fields,
		})
	);
};

export const validateFileExtensions = (fileType: string) => {
	const fileExtensions = acceptableFileFormats.split(',');
	const type = '.' + fileType.split('/')[1];

	return fileExtensions.includes(type);
};

export const downloadBlobResponse = (response: any, fileName: string) => {
	const blobType = response.headers?.['content-type'] || 'application/octet-stream';
	const blob = response.data instanceof Blob ? response.data : new Blob([response.data], { type: blobType });
	const url = window.URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.download = fileName;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	window.URL.revokeObjectURL(url);
};

export const getCompanyName = (companyHebrewName, companyEnglishName, selectedLang) => {
	const companyName = selectedLang === 'he' ? companyHebrewName : companyEnglishName;
	return companyName || '';
};

export const getCompanyLetter = (companyHebrewName, companyEnglishName, selectedLang) => {
	const companyLetter = selectedLang === 'he' ? companyHebrewName?.charAt(0) : _.upperCase(companyEnglishName)[0];
	return companyLetter || '';
};

export const getUserName = (englishName, hebrewName, selectedLanguage) => {
	const name = selectedLanguage === 'he' ? hebrewName : englishName;
	return name || '';
};

export const formatUTCdate = (date: Date, start?: boolean) => {
	const hour = start ? 0 : 23;
	const minutes = start ? 0 : 59;
	try {
		return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), hour, minutes));
	} catch (e) {
		return date;
	}
};

export const getFormattedNumber = (number: string | number | null | undefined) => {
	const value = Number(number);
	if (_.isNil(number) || number === '' || !Number.isFinite(value)) {
		return number;
	}

	return value.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

const AMOUNT_DECIMAL_LIMIT = 2;

// Returns the raw numeric amount string stored in form state.
export const getRawAmountInputValue = (value?: string | number | null) => {
	if (value == null) return '';

	const [integer, ...decimals] = String(value).replace(/[^\d.]/g, '').split('.');

	return decimals.length ? `${integer}.${decimals.join('').slice(0, AMOUNT_DECIMAL_LIMIT)}` : integer;
};

// Returns the comma-formatted amount string shown in the input.
export const getFormattedAmountInputDisplayValue = (value?: string | number | null) => {
	const rawValue = getRawAmountInputValue(value);

	if (!rawValue) return '';

	const [integer, decimal] = rawValue.split('.');
	const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

	return rawValue.includes('.') ? `${formattedInteger}.${decimal ?? ''}` : formattedInteger;
};
